import {
  EPromoType,
  EProviderType,
  IPromoSearchItemSchema,
} from '../../repositories/newbuilding-promos/entities/promo_search_result/PromoSearchItemSchema';
import { IPromoProp } from '../../types/promos/promoProp';

interface IGetSearchItemProps {
  promoDescription?: string;
  providerLogo?: string;
  providerName?: string;
  uniquePromoId?: string;
  actionName?: string;
  newbuildingIds?: number[] | null;
  promoProps?: IPromoProp[] | null;
}

export const getSearchItemMk = (props: IGetSearchItemProps) => {
  const {
    promoDescription = 'Ставка 3,5% действует при оформлении комлексного страхования.',
    providerLogo = 'https://www.cian.ru/api/get-company-logo/?id=9&rnd=433390',
    providerName = 'Самолет',
    uniquePromoId = '12321332',
    actionName = 'Подробнее',
    newbuildingIds = [6733, 9],
    promoProps = [
      { title: 'Ставка', value: '5,7%' },
      { title: 'Первый взнос', value: '20%' },
      { title: 'Сумма кредита', value: 'до 12 млн ₽' },
      { title: 'Срок акции', value: 'до 30.12.2024' },
    ],
  } = props;

  const item: IPromoSearchItemSchema = {
    uniquePromoId,
    promoName: 'Скидка 1 457 800 руб.',
    promoType: EPromoType.Bonus,
    providerType: EProviderType.Bank,
    providerPromoId: 12321332,
    providerLogo,
    newbuildingIds,
    promoPopup: {
      promoName: 'Бонус - кладовка',
      banks: [
        {
          name: 'Альфа-банк',
          logo: 'https://www.cian.ru/avatar.axd?i=58438719&t=2&p=2',
        },
        {
          name: 'ВТБ',
          logo: 'https://www.cian.ru/avatar.axd?i=58438719&t=2&p=2',
        },
      ],
      builders: [
        {
          name: 'ВТБ',
          logo: 'newbuilding_card_kpn_logo.png',
        },
      ],
      promoDescription,
      // @ts-expect-error TODO: Убрать директиву в CD-203174
      isNewbuildingCountTextLinkable: true,
      newbuildingCountText: 'Акция проходит в 13 ЖК',
      newbuildingIds: [6733, 9],
      newbuildingLinks: [
        {
          name: 'ЖК «Итальянский»',
          url: 'https://zhk-italyanskiy-kvartal-i.cian.ru/',
        },
        {
          name: 'ЖК «Дзен-кварталы»',
          url: 'https://zhk-dzen-kvartaly-i.cian.ru/',
        },
      ],
      // TODO: Удалить в CD-203170
      newbuildingListingUrlDesktop: 'https://www.cian.ru/novostroyki/',
      // TODO: Удалить в CD-203170
      newbuildingListingUrlMobile: 'https://www.cian.ru/novostroyki/',
      providerLogo,
      // TODO: Удалить в CD-203170
      promoProps: [
        {
          title: 'Ставка',
          value: '3,5%',
        },
      ],
      // TODO: Удалить в CD-203170
      actionName,
    },
    providerName,
    promoTypeText: 'Скидка',
    activeDateToText: 'до 30 ноября',
    isFromSeller: false,
    labels: [
      { text: '', type: 'mortgage' },
      { text: 'В 23 ЖК', type: 'newbuildingCount' },
    ],
    promoProps,
  };

  return item;
};
